// extracted by mini-css-extract-plugin
module.exports = {"root":"Y2PiQ","section":"QR5LQ","label":"_9cxWP"};